module.exports = __webpack_public_path__ + "media/images/add-82f49f5604ce6b6d0abb16ae34e1fbc6.png";